import React, { useEffect } from 'react';
import { connect, useSelector } from 'react-redux';
import { get } from 'lodash';
import { Grid } from '@material-ui/core';
import { injectIntl, IntlShape } from 'react-intl';
import { createStructuredSelector } from 'reselect';

import CommonLayout from 'components/CommonLayout';
import messages from 'containers/FaqPage/messages';
import { AssuranceIcon } from 'images';
import { translate } from 'helpers/intl';
import FaqFilter from 'components/FaqFilter';
import AccordionFaq from 'components/AccordionFaq';
import { getFaqsSelector, getSearchFaqSelector } from 'store/global/selectors';
import {
  getFaq,
  setFaq,
  setSearchFaq,
  setSelectedFaq,
} from 'store/global/actions';
import {
  renderTitleFaq,
  renderTagsFaq,
  renderIconFaq,
  renderBgFaq,
} from 'utils/string';
import { getLocaleSelector } from 'store/LanguageProvider/selectors';
import { StyledContainer } from 'containers/FaqPage/styles';

const FaqPage = (props: {
  intl: IntlShape;
  getFaq: Function;
  faq: [];
  searchedFaq: [];
  setFaq: Function;
  setSearchFaq: Function;
  setSelectedFaq: Function;
}) => {
  const language = useSelector(getLocaleSelector);

  /* eslint-disable */
  useEffect(() => {
    props.getFaq(language);
  }, [language]);
  /* eslint-enable */
  return (
    <CommonLayout
      title={messages.title}
      icon={
        <img
          height="30px"
          width="30px"
          src={get(AssuranceIcon, 'questionFaq')}
          alt="question-faq-icon"
        />
      }
      subTitle={translate({ ...messages.subTitle }, props)}
      content={
        <StyledContainer maxWidth="sm">
          <Grid container direction="column" spacing={3}>
            <Grid item>
              <FaqFilter
                getFaq={props.getFaq}
                faq={props.faq}
                setSearchFaq={props.setSearchFaq}
              />
            </Grid>
            {props.searchedFaq.length > 0
              ? props.searchedFaq &&
                props.searchedFaq.map(
                  /* istanbul ignore next */
                  (item: {
                    code: string;
                    body: {
                      question: string;
                      reponse: string;
                      id: number;
                    }[];
                  }) => (
                    <Grid item>
                      <AccordionFaq
                        BgImage={renderBgFaq(item.code)}
                        IconTypeFaq={renderIconFaq(item.code)}
                        title={translate(
                          get(messages, renderTitleFaq(item.code)),
                          props,
                        )}
                        keyWord={translate(
                          get(messages, renderTagsFaq(item.code)),
                          props,
                        )}
                        faqDetails={item.body}
                        code={item.code}
                        setSelectedFaq={props.setSelectedFaq}
                      />
                    </Grid>
                  ),
                )
              : props.faq &&
                props.faq.map(
                  /* istanbul ignore next */
                  (item: {
                    code: string;
                    body: {
                      question: string;
                      reponse: string;
                      id: number;
                    }[];
                  }) => (
                    <Grid item>
                      <AccordionFaq
                        BgImage={renderBgFaq(item.code)}
                        IconTypeFaq={renderIconFaq(item.code)}
                        title={translate(
                          get(messages, renderTitleFaq(item.code)),
                          props,
                        )}
                        keyWord={translate(
                          get(messages, renderTagsFaq(item.code)),
                          props,
                        )}
                        faqDetails={item.body}
                        code={item.code}
                        setSelectedFaq={props.setSelectedFaq}
                      />
                    </Grid>
                  ),
                )}
          </Grid>
        </StyledContainer>
      }
    />
  );
};
const mapDispatchToProps = {
  getFaq,
  setFaq,
  setSearchFaq,
  setSelectedFaq,
};
const mapStateToProps = createStructuredSelector<
  any,
  {
    faq: [];
    searchedFaq: [];
  }
>({
  faq: getFaqsSelector,
  searchedFaq: getSearchFaqSelector,
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(FaqPage));
export { FaqPage };
